var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader post-block"},[_c('div',{staticClass:"image"}),_vm._l((3),function(i){return _c('div',{key:i,staticClass:"text",style:('width:'+_vm.textWidth()+'%')})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }